import {getPrivateAxios} from '../../libs';
import {CropImage} from './types';

export const fetchCropImage = async (crop: CropImage) => {
  const {data} = await getPrivateAxios().post<string>('/files/crop-image', crop);
  return data;
};
